<template>
  <div class="d-flex justify-space-between align-center">
    <div class="d-flex">
      <v-select
        label="Catégorie"
        class="mx-2 flex-grow-0"
        clearable
        outlined
        dense
        v-model="category"
        :items="categories"
        item-text="title"
        item-value="id"
      />
      <v-select
        clearable
        outlined
        dense
        label="Nature"
        class="mx-2 flex-grow-0"
        v-model="nature"
        :items="natures"
        item-text="title"
        item-value="id"
        :no-data-text="generateMessage('properties.documents.noCategory')"
      />
      <div>
        <div class="font-weight-bold">Interne</div>
        <div class="my-1 d-inline-flex align-top">
          <v-checkbox
            class="ma-0 pa-0"
            hide-details
            dense
            :input-value="internal | hasValue(true)"
            label="Oui"
            @change="handleInternalChange(true)"
          />
          <v-checkbox
            class="ma-0 pa-0"
            hide-details
            dense
            :input-value="internal | hasValue(false)"
            label="Non"
            @change="handleInternalChange(false)"
          />
        </div>
      </div>
    </div>
    <v-btn class="text-none my-2" @click="clearFilters" color="primary" text>
      <v-icon>{{ generateMessage('boilerplate.icons.refresh') }}</v-icon>
      <span class="text-decoration-underline">
        {{ generateMessage('boilerplate.filters.reset') }}
      </span>
    </v-btn>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { generateMessage } from '@/utils/i18n';

const { mapGetters, mapActions } = createNamespacedHelpers('documents');
export default {
  name: 'DocumentsHorizontalFilters',
  computed: {
    ...mapGetters(['categories', 'filters']),
    natures() {
      const category = this.categories.find(
        (item) => item.id === this.filters.category
      );
      return category ? category.natures : [];
    },
    category: {
      get() {
        return this.filters.category;
      },
      set(value) {
        this.setFilterAttribute({ attribute: 'category', value });
      },
    },
    nature: {
      get() {
        return this.filters.nature || [];
      },
      set(value) {
        this.setFilterAttribute({ attribute: 'nature', value });
      },
    },
    internal: {
      get() {
        return this.filters.internal || [];
      },
      set(value) {
        this.setFilterAttribute({ attribute: 'internal', value });
      },
    },
  },
  filters: {
    hasValue(item, value) {
      return item.some((el) => el === value);
    },
  },
  methods: {
    generateMessage,
    ...mapActions(['setFilterAttribute', 'clearFilters']),
    handleInternalChange(value) {
      if (this.internal.some((el) => el === value)) {
        this.internal = this.internal.filter((el) => el !== value);
      } else {
        this.internal = this.internal.concat([value]);
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
